<script>
import { showModal } from '@app/store/modalStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    markerState
} from '@app/store/markerStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { clickoutside } from '@svelte-put/clickoutside';
import Swal from 'sweetalert2';
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';
import {
    saveAs
} from 'file-saver';
import {
    unparse
} from 'papaparse';
import {
    v4 as uuidv4
} from "uuid";
import tcLib from "@cclib/lib/timecode.js";
import _Marker from "@cclib/classes/marker.js";
import _EventGroup from "@cclib/classes/eventGroup.js";
import _Event from "@cclib/classes/event.js";
import * as m from "@app/paraglide/messages.js";

const hexColors = [
    "#ff66cc", "#00cc00", "#0066ff", "#6600ff", "#ff0066",
    "#6666ff", "#00cc99", "#99ccff", "#ff9966", "#ff33cc",
    "#009900", "#ff9933", "#009999", "#333399", "#999966",
    "#99ccff", "#990033", "#996600", "#ffcc99", "#6699ff"
];

let selectedMarker = $state(), showMenu = $state(false);

async function createMarkerList() {
    console.log("Creating new marker list");
    let res = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.markers_new_list_title(),
        showCancelButton: true,
        confirmButtonText: m.markers_create_button(),
        input: 'text',
        inputLabel: m.markers_list_name_label(),
        inputPlaceholder: m.markers_list_name_placeholder(),
        customClass: SWAL_CLASSES.confirmCancel,
    });

    if (res.isConfirmed && res.value) {
        markerState.lists = [...markerState.lists, {
            id: uuidv4(),
            name: res.value,
            color: hexColors[Math.floor(Math.random() * 20)],
            markers: []
        }]

        markerState.selected = markerState.lists.length - 1;
    }
}

async function removeMarkerList() {
    if (markerState.selected === 0) {
        //Shot Change List
        return;
    }

    let res = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.markers_remove_list_title(),
        showCancelButton: true,
        confirmButtonText: m.markers_yes_button(),
        text: m.markers_remove_list_confirm(),
        customClass: SWAL_CLASSES.confirmCancel,
    });

    if (res.isConfirmed) {
        let markerListToDelete = markerState.lists[markerState.selected].id;
        markerState.selected = 0;
        markerState.lists = markerState.lists.filter(list => {
            return list.id !== markerListToDelete;
        });
    }
}

async function addMarkerToList(e) {
    let res = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.markers_new_marker_title(),
        showCancelButton: true,
        confirmButtonText: m.markers_add_marker_button(),
        input: 'textarea',
        inputLabel: m.markers_comment_label(),
        inputPlaceholder: m.markers_comment_placeholder(),
        customClass: SWAL_CLASSES.confirmCancel,
    });

    if (res.isConfirmed) {
        const selectedList = markerState.lists[markerState.selected];
        const marker = {...(new _Marker({
            time: window.player.currentTime || 0,
            comment: res.value || ""
        }))};

        selectedList.markers = [...selectedList.markers, marker];

        //Sort markers in list by time
        selectedList.markers.sort((a, b) => {
            return a.time - b.time;
        });
    }

    e.target.blur();
}

async function editMarker(e) {
    let res = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.markers_edit_marker_title(),
        showCancelButton: true,
        confirmButtonText: m.markers_update_marker_button(),
        input: 'textarea',
        inputLabel: m.markers_comment_label(),
        inputValue: selectedMarker.comment,
        inputPlaceholder: m.markers_comment_placeholder(),
        customClass: SWAL_CLASSES.confirmCancel,
    });

    if (res.isConfirmed) {
        selectedMarker.comment = res.value;
        selectedMarker.time = window.player ? window.player.currentTime : 0;

        let markerIndex = markerState.lists[markerState.selected].markers.findIndex(marker => {
            return marker.id === selectedMarker.id;
        });

        markerState.lists[markerState.selected].markers[markerIndex] = selectedMarker;
        markerState.lists[markerState.selected].markers.sort((a, b) => {
            return a.time - b.time;
        });
    }

    e.target.blur();
}

async function clearMarkerDescriptions(){
    let res = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.markers_clear_descriptions_title(),
        showCancelButton: true,
        confirmButtonText: m.markers_clear_button(),
        text: m.markers_clear_descriptions_confirm(),
        customClass: SWAL_CLASSES.confirmCancel,
    });

    if (res.isConfirmed) {
        markerState.lists[markerState.selected].markers.forEach((marker, index, markers) => {
            markers[index].comment = "";
        });

        
    }
}

function removeMarkerFromList(e) {
    let markerId = selectedMarker.id;
    selectedMarker = undefined;
    markerState.lists[markerState.selected].markers = markerState.lists[markerState.selected].markers.filter(marker => {
        return marker.id !== markerId;
    });

    e.target.blur();
}

function exportMarkers() {
    try {
        //Export marker lists as CSV using papaparse and file-saver.js
        let markersToExport = [];
        markerState.lists.forEach((list, listIndex) => {
            list.markers.forEach((marker, markerIndex) => {
                markersToExport.push({
                    [m.markers_export_id()]: `${listIndex}-${markerIndex}`,
                    [m.markers_export_time_seconds()]: marker.time,
                    [m.markers_export_time_smpte()]: tcLib.secToTc(marker.time + projectState.incode, projectState.frameRate, projectState.dropFrame),
                    [m.markers_export_end_time_seconds()]: marker.endTime !== false ? marker.endTime : "",
                    [m.markers_export_end_time_smpte()]: marker.endTime !== false ? tcLib.secToTc(marker.endTime + projectState.incode, projectState.frameRate, projectState.dropFrame) : "",
                    [m.markers_export_comment()]: marker.comment,
                    [m.markers_export_list()]: list.name
                });
            });
        });

        console.log(markersToExport);
        let csv = unparse(markersToExport, {
            header: true,
            columns: [
                m.markers_export_id(),
                m.markers_export_time_seconds(),
                m.markers_export_time_smpte(),
                m.markers_export_end_time_seconds(),
                m.markers_export_end_time_smpte(),
                m.markers_export_comment(),
                m.markers_export_list(),
            ]
        });

        let blob = new Blob([csv], {
            type: "text/csv;charset=utf-8"
        });
        //Use Swal to ask user for filename
        Swal.fire({
            ...SWAL_BASE,
            titleText: m.markers_export_title(),
            showCancelButton: true,
            confirmButtonText: m.markers_export_button(),
            input: 'text',
            inputLabel: m.markers_filename_label(),
            inputPlaceholder: m.markers_filename_placeholder(),
            customClass: SWAL_CLASSES.confirmCancel,
        }).then(res => {
            if (res.isConfirmed && res.value) {
                saveAs(blob, res.value + ".csv");
            }
        });
    } catch (err) {
        console.log(err, "Error exporting markers");
    } finally {
        showMenu = false;
    }
}

async function createEventGroup() {
    try {
        // Create a new Event Group using the marker timings of the selected list
        let markerAtStartOfEvent = true
        let eventGroupDefaults = JSON.parse(localStorage.getItem("cc-event-group-defaults")) || {};
        let evg = {...(new _EventGroup())};
        evg.name = markerState.lists[markerState.selected].name;
        evg.maxCps = eventGroupDefaults.maxCps || 9999;
        evg.maxWpm = eventGroupDefaults.maxWpm || 9999;
        evg.maxChars = eventGroupDefaults.maxChars || 9999;
        evg.maxLines = eventGroupDefaults.maxLines || 9999;
        evg.maxDuration = eventGroupDefaults.maxDuration || 9999;
        evg.minDuration = eventGroupDefaults.minDuration || 0.1;
        evg.overlap = eventGroupDefaults.overlap;
        evg.illegalChars = eventGroupDefaults.illegalChars;
        evg.fontFamily = eventGroupDefaults.fontFamily ?? "plexMono";
        evg.fontSize = eventGroupDefaults.fontSize || 16;

        // Ask the user if the marker times should be used as the start of the event or the end
        let swalRes = await Swal.fire({
            ...SWAL_BASE,
            titleText: m.markers_create_event_group_title(),
            text: m.markers_create_event_group_question(),
            showCancelButton: true,
            confirmButtonText: m.markers_create_event_group_start_time(),
            cancelButtonText: m.markers_create_event_group_end_time(),
            customClass: SWAL_CLASSES.confirmCancel,
        });
        
        if (swalRes.isConfirmed) {
            markerAtStartOfEvent = true;
        } else {
            markerAtStartOfEvent = false;
        }
        
        if (markerAtStartOfEvent){
            markerState.lists[markerState.selected].markers.forEach((marker, index, markers) => {
                evg.events.push({...(new _Event({
                    start: marker.time,
                    end : index === markers.length - 1 ? projectState.duration : markers[index + 1].time,
                    notes: marker.comment
                }))});
            });
        } else {
            markerState.lists[markerState.selected].markers.forEach((marker, index, markers) => {
                evg.events.push({...(new _Event({
                    start: index === 0 ? 0 : markers[index - 1].time,
                    end : marker.time,
                    notes: marker.comment
                }))});
            });
        }
        
        eventGroupState.push(evg);
        projectState.selected = eventGroupState.length - 1;


        toast.push(m.markers_event_group_created(), {classes: ['toast-success']});

        /* Store in History */
        insertHistoryAction({
            name: "insert Event Group", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err, "Error exporting markers");
    } finally {
        showMenu = false;
    }
}
</script>

<div class="row g-2">
    <div class="col-9">
        <form id="markers-form" aria-label={m.markers_form_label()}>
            <select 
                id="marker-list-select"
                class="form-select form-select-sm" 
                bind:value={markerState.selected}
                aria-label={m.markers_select_list_label()}
            >
                {#each markerState.lists as markerList, index (markerList.id)}
                <option value={index} style="background-color: {markerList.color}">{markerList.name}</option>
                {/each}
            </select>
            <select 
                id="marker-entries"
                class="form-select form-select-sm resize-vertical" 
                size="8" 
                bind:value={selectedMarker} 
                onchange={() => window.player ? window.player.currentTime = selectedMarker.time : null}
                aria-label={m.markers_select_marker_label()}
            >
                {#each markerState.lists[markerState.selected].markers as marker (marker.id)}
                <option value={marker}>{tcLib.secToTc(marker.time+projectState.incode, projectState.frameRate, projectState.dropFrame)} | {marker.comment}</option>
                {/each}
            </select>
        </form>
    </div>
    <div class="col-3 align-items-end">
        <div class="btn-group btn-group-sm mb-3" role="group" aria-label={m.markers_list_actions_label()}>
            <button type="button" id="new-list-btn" class="btn btn-light" aria-label={m.markers_new_list_label()} onclick={createMarkerList}><i class="bi bi-plus-lg"></i></button>
            <button type="button" id="remove-list-btn" class="btn btn-light" aria-label={m.markers_remove_list_label()} disabled={markerState.selected === 0} onclick={removeMarkerList}><i class="bi bi-dash-lg"></i></button>
        </div>
        <div class="dropdown float-end overflow-x-visible" use:clickoutside onclickoutside={()=> showMenu = false}>
            <button aria-label={m.markers_show_menu_label()} class="btn btn-light btn-sm" type="button" onclick={() => showMenu = true}>
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu {showMenu ? 'show' : ''}">
                <li><a class="dropdown-item" href="#!/" onclick={() => showModal("markerImport")}><i class="bi bi-file-earmark-ruled"></i> {m.markers_import_menu()}</a></li>
                <li><a class="dropdown-item" href="#!/" onclick={() => exportMarkers()}><i class="bi bi-filetype-csv"></i> {m.markers_export_csv_menu()}</a></li>
                <li><a class="dropdown-item" href="#!/" onclick={() => clearMarkerDescriptions()}><i class="bi bi-eraser"></i> {m.markers_clear_descriptions_menu()}</a></li>
                <li><a class="dropdown-item" href="#!/" onclick={() => createEventGroup()}>{m.markers_create_event_group_menu()}</a></li>
            </ul>
        </div>
        <button type="button" id="add-marker-btn" class="btn btn-primary w-100 mb-1" onclick={addMarkerToList} aria-label={m.markers_add_marker_label()}>{m.markers_add_marker_button()}</button>
        <button type="button" id="edit-marker-btn" class="btn btn-outline-dark w-100 mb-1" disabled={!selectedMarker} onclick={editMarker} aria-label={m.markers_edit_marker_label()}>{m.markers_edit_marker_button()}</button>
        <button type="button" id="remove-marker-btn" class="btn btn-danger w-100 mb-1" disabled={!selectedMarker} onclick={removeMarkerFromList} aria-label={m.markers_remove_marker_label()}>{m.markers_remove_marker_button()}</button>
    </div>
</div>
<style lang="css">
    .dropdown-menu {
        position: absolute;
        right: 0px;
        top: 35px;
    }
</style>